import React, { useEffect, useState } from "react";
import axios from "axios";
import "@fontsource/chivo";


const MenuManager = () => {
  const [menuData, setMenuData] = useState([]);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [newItem, setNewItem] = useState({
    categoria: "",
    nome: "",
    prezzo: "",
    stock: "",
    stato: "ATTIVO",
    image: null,
    ingredienti: "",
    allergeni: "",
  });
  
  const [addStatus, setAddStatus] = useState(null); // success or error message
  const [editingId, setEditingId] = useState(null);
const [editedItem, setEditedItem] = useState({});

  
  

  const fetchMenu = () => {
    axios
      .get("https://api.lidodavittorio.it/api/menu-table")
      .then((res) => {
        const flat = Object.entries(res.data).flatMap(([categoria, items]) =>
          items.map((item) => ({ ...item, categoria }))
        );
        setMenuData(flat);
      })
      .catch((err) => console.error("Errore nel caricamento menu:", err));
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  const handleAddNew = () => {
    const { categoria, nome, prezzo, stock, stato, image } = newItem;
  
    if (!categoria || !nome || !prezzo || !stock) {
      setAddStatus("❌ Tutti i campi sono obbligatori.");
      return;
    }
  
    const formData = new FormData();
    formData.append("categoria", categoria);
    formData.append("nome", nome);
    formData.append("prezzo", prezzo);
    formData.append("stock", stock);
    formData.append("stato", stato);
    formData.append("ingredienti", newItem.ingredienti);
    formData.append("allergeni", newItem.allergeni);

    if (image) formData.append("image", image);
  
    axios
      .post("https://api.lidodavittorio.it/api/menu/add", formData)
      .then(() => {
        setAddStatus("✅ Elemento aggiunto con successo!");
        setNewItem({ categoria: "", nome: "", prezzo: "", stock: "", stato: "ATTIVO", image: null });
        fetchMenu();
      })
      .catch(() => setAddStatus("❌ Errore durante l'aggiunta."));
  };
  

  const handleDelete = (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo elemento?")) return;
  
    axios
      .post("https://api.lidodavittorio.it/api/menu/delete", { id })
      .then(() => {
        setAddStatus("🗑️ Elemento eliminato con successo!");
        fetchMenu();
      })
      .catch((err) => {
        console.error("Errore eliminazione:", err);
        setAddStatus("❌ Errore durante l'eliminazione.");
      });
  };
  
  const handleEditClick = (item) => {
    setEditingId(item.id);
    setEditedItem({ ...item });
  };
  
  const handleEditChange = (field, value) => {
    setEditedItem((prev) => ({ ...prev, [field]: value }));
  };
  
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedItem({});
  };
  
  const handleSaveEdit = () => {
    const { id, nome, prezzo, stock, stato, image } = editedItem;
    const formData = new FormData();
    formData.append("id", id);
    formData.append("nome", nome);
    formData.append("prezzo", prezzo);
    formData.append("stock", stock);
    formData.append("stato", stato);
    if (image) formData.append("image", image);
    formData.append("ingredienti", editedItem.ingredienti || "");
    formData.append("allergeni", editedItem.allergeni || "");

  
    axios
      .post("https://api.lidodavittorio.it/api/menu/update", formData)
      .then(() => {
        setAddStatus("✅ Modificato con successo!");
        setEditingId(null);
        setEditedItem({});
        fetchMenu();
      })
      .catch(() => setAddStatus("❌ Errore durante la modifica."));
  };
  
  

  const filteredMenu = menuData.filter(
    (item) =>
      item.nome.toLowerCase().includes(filter.toLowerCase()) ||
      item.categoria.toLowerCase().includes(filter.toLowerCase())
  );

  // Pagination logic
  const totalPages = Math.ceil(filteredMenu.length / itemsPerPage);
  const paginatedMenu = filteredMenu.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <div className="overflow-x-auto">
      <h2 className="text-2xl font-bold font-[chivo] text-[#009FB7] mb-6">
        Gestione Menu
      </h2>
  
      {/* Filter Input */}
      <div className="mb-4 font-[chivo]">
        <input
          type="text"
          placeholder="Filtra per nome o categoria..."
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="border px-3 py-2 rounded w-full sm:w-1/2"
        />
      </div>
  
      {/* Add New Item Form */}
      <div className="mb-4 flex flex-wrap gap-2 font-[chivo]">
        <input
          type="text"
          placeholder="Categoria"
          value={newItem.categoria}
          onChange={(e) => setNewItem({ ...newItem, categoria: e.target.value })}
          className="border px-2 py-1 rounded w-full sm:w-[150px]"
        />
        <input
          type="text"
          placeholder="Nome"
          value={newItem.nome}
          onChange={(e) => setNewItem({ ...newItem, nome: e.target.value })}
          className="border px-2 py-1 rounded w-full sm:w-[150px]"
        />
        <input
          type="number"
          placeholder="Prezzo"
          value={newItem.prezzo}
          onChange={(e) => setNewItem({ ...newItem, prezzo: e.target.value })}
          className="border px-2 py-1 rounded w-full sm:w-[100px]"
        />
        <input
          type="number"
          placeholder="Stock"
          value={newItem.stock}
          onChange={(e) => setNewItem({ ...newItem, stock: e.target.value })}
          className="border px-2 py-1 rounded w-full sm:w-[100px]"
        />

<input
  type="text"
  placeholder="Ingredienti"
  value={newItem.ingredienti}
  onChange={(e) => setNewItem({ ...newItem, ingredienti: e.target.value })}
  className="border px-2 py-1 rounded w-full sm:w-[200px]"
/>

<input
  type="text"
  placeholder="Allergeni"
  value={newItem.allergeni}
  onChange={(e) => setNewItem({ ...newItem, allergeni: e.target.value })}
  className="border px-2 py-1 rounded w-full sm:w-[200px]"
/>

        <input
  type="file"
  accept="image/*"
  onChange={(e) => setNewItem({ ...newItem, image: e.target.files[0] })}
  className="border px-2 py-1 rounded w-full sm:w-[200px]"
/>

        <select
          value={newItem.stato}
          onChange={(e) => setNewItem({ ...newItem, stato: e.target.value })}
          className="border px-2 py-1 rounded w-full sm:w-[130px]"
        >
          <option value="ATTIVO">ATTIVO</option>
          <option value="NON ATTIVO">NON ATTIVO</option>
        </select>
        <button
          onClick={handleAddNew}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
        >
          ➕ Aggiungi
        </button>
      </div>
  
      {/* Add/Edit Status Message */}
      {addStatus && (
        <div className="mb-4 text-sm font-semibold text-center text-[#009FB7]">
          {addStatus}
        </div>
      )}
  
      {/* Table */}
      <table className="w-full border-collapse font-[chivo] text-sm sm:text-base">
        <thead>
          <tr className="bg-[#009FB7] text-white">
            <th className="p-3 border">Categoria</th>
            <th className="p-3 border">Nome</th>
            <th className="p-3 border">Prezzo</th>
            <th className="p-3 border">Stock</th>
            <th className="p-3 border">Ingredienti</th>
<th className="p-3 border">Allergeni</th>

            <th className="p-3 border">Immagine</th>
            <th className="p-3 border">Stato</th>
            <th className="p-3 border text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {paginatedMenu.map((item) => (
            <tr key={item.id} className="border-b hover:bg-gray-100">
              <td className="p-3">{item.categoria}</td>
  
              {/* Nome */}
              <td className="p-3">
                {editingId === item.id ? (
                  <input
                    type="text"
                    value={editedItem.nome}
                    onChange={(e) => handleEditChange("nome", e.target.value)}
                    className="w-full border px-2 py-1 rounded"
                  />
                ) : (
                  item.nome
                )}
              </td>
  
              {/* Prezzo */}
              <td className="p-3">
                {editingId === item.id ? (
                  <input
                    type="number"
                    value={editedItem.prezzo}
                    onChange={(e) => handleEditChange("prezzo", e.target.value)}
                    className="w-full border px-2 py-1 rounded"
                  />
                ) : (
                  <>€{parseFloat(item.prezzo).toFixed(2)}</>
                )}
              </td>
  
{/* Stock */}
<td className="p-3">
  {editingId === item.id ? (
    <input
      type="number"
      value={editedItem.stock}
      onChange={(e) => handleEditChange("stock", e.target.value)}
      className="w-full border px-2 py-1 rounded"
    />
  ) : (
    <span
      className={`font-bold ${
        item.stock < 10
          ? "text-red-600"
          : item.stock < 30
          ? "text-orange-500"
          : "text-green-600"
      }`}
    >
      {item.stock}
    </span>
  )}
</td>

<td className="p-3">
  {editingId === item.id ? (
    <input
      type="text"
      value={editedItem.ingredienti || ""}
      onChange={(e) => handleEditChange("ingredienti", e.target.value)}
      className="w-full border px-2 py-1 rounded"
    />
  ) : (
    item.ingredienti
  )}
</td>

<td className="p-3">
  {editingId === item.id ? (
    <input
      type="text"
      value={editedItem.allergeni || ""}
      onChange={(e) => handleEditChange("allergeni", e.target.value)}
      className="w-full border px-2 py-1 rounded"
    />
  ) : (
    item.allergeni
  )}
</td>


<td className="p-3">
  {editingId === item.id ? (
    <input
      type="file"
      accept="image/*"
      onChange={(e) =>
        setEditedItem((prev) => ({ ...prev, image: e.target.files[0] }))
      }
      className="border px-2 py-1 rounded w-full sm:w-[200px]"
    />
  ) : item.imageUrl ? (
    <div className="flex justify-center items-center">
    <img
      src={`https://api.lidodavittorio.it${item.imageUrl}`}
      alt={item.nome}
      className="w-16 h-16 object-cover rounded"
    />
        </div>
  ) : (
    <div className="text-center text-gray-400 italic">Nessuna</div>
  )}
</td>




  
              {/* Stato */}
              <td className="p-3">
                {editingId === item.id ? (
                  <select
                    value={editedItem.stato}
                    onChange={(e) => handleEditChange("stato", e.target.value)}
                    className="w-full border px-2 py-1 rounded"
                  >
                    <option value="ATTIVO">ATTIVO</option>
                    <option value="NON ATTIVO">NON ATTIVO</option>
                  </select>
                ) : (
                  <span
                    className={`font-bold ${
                      item.stato === "ATTIVO" ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {item.stato}
                  </span>
                )}
              </td>
  
              {/* Action Buttons */}
              <td className="p-3 text-center space-x-1">
                {editingId === item.id ? (
                  <>
                    <button
                      onClick={handleSaveEdit}
                      className="bg-[#009FB7] text-white px-2 py-1 rounded hover:bg-[#007a91]"
                    >
                      Salva
                    </button>
                    <button
                      onClick={handleCancelEdit}
                      className="bg-gray-400 text-white px-2 py-1 rounded hover:bg-gray-500"
                    >
                      Annulla
                    </button>
                  </>
                ) : (
                  <>
<button
  onClick={() => handleEditClick(item)}
  className="text-yellow-500 text-lg hover:text-yellow-600"
  title="Modifica"
>
  ✏️
</button>

                    <button
                      onClick={() => handleDelete(item.id)}
                      className="text-red-600 font-bold px-2 hover:text-red-800"
                      title="Elimina"
                    >
                      🗑
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
  
      {/* Pagination Controls */}
      <div className="flex justify-center items-center gap-4 font-[chivo] mt-6">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          ◀ Precedente
        </button>
  
        <span>
          Pagina <strong>{currentPage}</strong> di <strong>{totalPages}</strong>
        </span>
  
        <button
          onClick={() => handlePageChange("next")}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          Prossimo ▶
        </button>
      </div>
    </div>
  );
  
  
  
};

export default MenuManager;
